module.exports = __webpack_public_path__ + "img/userBg.141b8f22.svg";